<template>
  <div>
    <a-form-modelCols
      v-model="data"
      class="pb-1 mx-1 mt-1"
      :model="getFormModel(['text#8', 'action#4', 'action_text#12', 'task_id#6', 'status_id#6', 'group_id', 'forms#12', 'taskFields#12', 'actionFields'])"
      :values="data"
      :errors="errors"
      :config="{ dense: true, readonly, hideDetails: true }"
      @validate="onInput($event)"
    />
  </div>
</template>

<script>
import { getForm, getAccess, libChecks, submitForm } from "@/components/mixings";
export default {
  name: "a-b",
  mixins: [getForm, libChecks, getAccess, submitForm],
  props: {
    value: Object,
    values: Object,
    config: {
      type: Object,
      default: () => {
        return { dense: true, hideDetails: "auto" };
      },
    },
    readonly: { type: Boolean, default: false },
    object: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  computed: {
    taskList() {
      return (this.config?.opt?.tasks || []).map((m) => {
        return { text: `#${m.id} ${m.name}`, value: m.id };
      });
    },
    statusList() {
      return (this.config?.opt?.statuses || []).map((m) => {
        return { text: `#${m.id} ${m.name}`, value: m.id };
      });
    },
    groupList() {
      return (this.config?.opt?.groups || []).map((m) => {
        return { text: `#${m.id} ${m.name}`, value: m.id };
      });
    },
    model() {
      let type = [
        { value: "createTask", text: "Создать задачу.." },
        { value: "changeGroup", text: "Перевести в воронку.." },
      ];
      let res = [
        { name: "text", title: "Результат", type: "string", validator: ["req"] },
        { name: "action_text", title: "Выполненное действие", type: "string", validator: ["req"] },
        {
          name: "action",
          title: "Действие",
          type: "select",
          options: type,
          validator: ["req"],

          readonly: false,
        },
        {
          name: "task_id",
          title: "Создать задачу",
          type: "select",
          options: this.taskList,
          hidden: this.data.action == "changeGroup" || !this.data.action,
          //shidden: !this.data.action,
        },
        {
          name: "forms",
          title: "Заполнить форму",
          type: "select",
          chips: true,
          options: "models.dir_leadsGroup.leads_task_template.leadsForms",
          hidden: !this.data.action,
        },
        {
          name: "taskFields",
          title: "Указать значение для новой задачи",
          type: "select",
          chips: true,
          options: "models.dir_leadsGroup.leads_task_template.inputTaskFields",
          hidden: !this.data.action,
        },
        {
          name: "actionFields",
          title: "Указать значение для выполненого действия",
          type: "select",
          chips: true,
          options: "models.dir_leadsGroup.leads_task_template.inputActionFields",
          hidden: !this.data.action,
        },
        {
          name: "status_id",
          title: "Перевести в этап",
          type: "select",
          options: this.statusList,
          //hidden: !this.data.action,
          hidden: this.data.action == "changeGroup" || !this.data.action,
          //type: "selectapi",
          //itemField: { text: "name", value: "id" },
          //api: "mechti/leads_status",
          //filters: { formula: "(d)=>{return {leads_status_group_id: d.leads_status_group_id}}" },
        },
        {
          name: "group_id",
          title: "Перевести в воронку",
          type: "select",
          options: this.groupList,
          //hidden: !this.data.action,
          hidden: this.data.action !== "changeGroup" || !this.data.action,
          //type: "selectapi",
          //itemField: { text: "name", value: "id" },
          //api: "mechti/leads_status",
          //filters: { formula: "(d)=>{return {leads_status_group_id: d.leads_status_group_id}}" },
        },
      ];
      return res;
    },
  },
  created() {
    this.updateData();
  },
  watch: {
    value(v) {
      this.updateData();
    },
  },
  methods: {
    async fetchData() {
      this.loading = true;
      let data = this.value;
      if (!data) this.isChanged = true;
      for (const name in data) {
        this.$set(this.data, name, data[name]);
        this.$set(this.errors, name, null);
      }
      this.loading = false;

      this.afterFetchData(data);
    },
    async post(data, api, silent = false) {
      this.loading = true;
      try {
        this.loading = false;
        this.$emit("commit", data);
        this.afterSave(data);
      } catch (error) {
        this.$root.$emit("show-info", {
          type: "error",
          text: "Ошибка при сохранении",
        });
        this.loading = false;
        return;
      }
    },
    onInput(e) {
      if (e == "action") {
        this.model.forEach((m) => {
          if (["task_id", "status_id"].includes(m.name)) m.validator = !m.hidden ? ["req1"] : null;
        });
        this.fillFormValidators(this.model);
      }
      this.$emit("change");
      this.submit(true);
    },
    commit() {
      this.$emit("input", this.list);
    },
    onClickDel(key) {
      let e = this.list;
      e.splice(key, 1);
      e.forEach((el, i) => {
        el.numb = i + 1;
      });
      this.list = e;
      this.commit();
      this.reset();
      if (this.curError?.id == key) {
        this.curError = {};
      }
    },
  },
};
</script>
